<div class="export-container">
  <span style="min-width: 290px; max-width: 290px; margin-top: auto; margin-bottom: auto;">
    {{export.name}}:
  </span>
  @for (option of export.options; track option) {
    <p-button
      type="submit"
      severity="success"  
      (click)="doExport(option.id)"
      [disabled]="isLoading"
      [label]="option.name"
      pTooltip="{{option.filterOn ? 'Filters on: ' + option.filterOn : 'No date filter'}}">
    </p-button>
  }
  @if (isLoading) {
    <span style="vertical-align: middle; margin-left: 5px;">
      <p-progressSpinner [style]="{width: '26px', height: '26px'}" strokeWidth="8" fill="#EEEEEE" animationDuration="1.5s"></p-progressSpinner>
    </span>
  }
  <br/>
</div>
<hr/>